/**
 * Helper: Format money
 * -----------------------------------------------------------------------------
 * Formats money into store format.
 *
 * @param {Number} value - Value in cents.
 * @param {String} format - Money format.
 * @returns {String}
 *
 */
import { formatMoney } from '@we-make-websites/theme-currency'

export default (value, format = cnvs.store.moneyFormat, removeZeros = false) => {
  const noSeparatorFormat = format
    .replace('_with_comma_separator', '')
    .replace('_with_apostrophe_separator', '')
    .replace('_with_space_separator', '')
    .replace('_with_period_and_space_separator', '')

  let money = formatMoney(value, noSeparatorFormat, removeZeros)

  // Prefix with currency code when currency symbol is $, but not USD
  if (
    cnvs.store.currency !== 'USD' &&
    cnvs.store.currencySymbol === '$' &&
    money.startsWith('$')
  ) {
    money = `${cnvs.store.currency}${money}`
  }

  // Fix bug where Shopify serves a $ in moneyFormat
  // for a few non-$ currencies, like Vanuatu's
  if (
    cnvs.store.currencySymbol !== '$' &&
    money.includes('$')
  ) {
    money = money.replace('$', cnvs.store.currencySymbol)
  }

  return money
}
